import i18next from "i18next";
import ChainedBackend from "i18next-chained-backend";
import LocizeBackend from "i18next-locize-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import appEn from "~/locales/en/app.json";
import appEs from "~/locales/es/app.json";

const locizeProjectId = import.meta.env.VITE_LOCIZE_PROJECT_ID ?? "";
const locizeVersion = import.meta.env.VITE_LOCIZE_VERSION ?? "latest";
const locizeApiKey = import.meta.env.VITE_LOCIZE_API_KEY ?? "";
const saveMissing = import.meta.env.DEV && import.meta.env.VITE_LOCIZE_SAVE_MISSING === "true";

const bundledResources: Record<string, Record<string, Record<string, unknown>>> = {
  en: {
    app: appEn,
  },
  es: {
    app: appEs,
  },
};

i18next
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    defaultNS: "app",
    ns: ["app"],
    supportedLngs: ["en", "es"],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing,
    backend: {
      backends: locizeProjectId
        ? [resourcesToBackend(bundledResources), LocizeBackend]
        : [resourcesToBackend(bundledResources)],
      backendOptions: locizeProjectId
        ? [
            {},
            {
              projectId: locizeProjectId,
              version: locizeVersion,
              apiKey: saveMissing ? locizeApiKey : undefined,
              referenceLng: "en",
            },
          ]
        : [{}],
    },
  });

export default i18next;
